import webContextProvider from "../../../../../../../providers/webContextProvider";

const getPageName = () => {
  const { platform, storeId } = webContextProvider();

  return `${platform} ${storeId}|See Similar Items`;
};

export default getPageName;
